<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  color: #fff;
  width: 100%;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
}

.imgTitle {
  font-weight: 600;
  font-size: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ddbc6e;
  img {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }
  span {
    color: #b2e0f3;
    padding: 0 10px;
    font-size: 56px;
    font-weight: 500;
  }
}
</style>
